import { Tooltip } from '@mui/material';
import { FC } from 'react';
import { ReactComponent as Icon } from '../../assets/icons/ox-built-in.svg';

const OxBuiltIn: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Tooltip arrow title='Ox Security built-in feature'>
      <Icon width='1.25rem' height='1.25rem' />
    </Tooltip>
  );
};

export default OxBuiltIn;
